import { render, staticRenderFns } from "./CesiumPlugin.vue?vue&type=template&id=bea80b5a&scoped=true"
import script from "./CesiumPlugin.vue?vue&type=script&lang=ts"
export * from "./CesiumPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CesiumPlugin.vue?vue&type=style&index=0&id=bea80b5a&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bea80b5a",
  null
  ,true
)

export default component.exports